// The report tells the keyboard sheet which of its views is on screen, so "?" lists only the keys that work there
// (the live cockpit has no replay and no T0/UTC toggle; a document does not follow a stream).
//   useReportKeys(variant)   the report page, while mounted · useReportKeysValue() → variant | null   the sheet
import { useEffect, useSyncExternalStore } from "react";

type ReportView = "queued" | "live" | "document" | "failed" | "cancelled-before";

let current: ReportView | null = null;
const listeners = new Set<() => void>();
const subscribe = (cb: () => void) => {
  listeners.add(cb);
  return () => void listeners.delete(cb);
};
const set = (v: ReportView | null) => {
  current = v;
  listeners.forEach((cb) => cb());
};

export function useReportKeys(view: ReportView) {
  useEffect(() => {
    set(view);
    return () => set(null);
  }, [view]);
}

export function useReportKeysValue(): ReportView | null {
  return useSyncExternalStore(subscribe, () => current, () => null);
}
